"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenshotUrl = void 0;
const getScreenshotUrl = (baseScreenshotURL, screenshotId, boundingBox) => {
    if (!baseScreenshotURL || !screenshotId) {
        return null;
    }
    const url = new URL(`${baseScreenshotURL}/api/screenshots/${screenshotId}`);
    if (boundingBox) {
        const boundingBoxString = JSON.stringify(boundingBox);
        url.searchParams.set('boundingBox', boundingBoxString);
    }
    return url.toString();
};
exports.getScreenshotUrl = getScreenshotUrl;
//# sourceMappingURL=get-screenshot-url.js.map